import OrderMethod from './OrderMethod';

export default {
  OrderMethod,
};
